import Vue from 'vue'
import Author from '../views/Author.vue'

Vue.config.productionTip = false

import VueResource from 'vue-resource'
Vue.use(VueResource)

new Vue({
  render: h => h(Author)
}).$mount('#app')
